module.exports = __webpack_public_path__ + "static/media/london-bank-district.192932d3.jpg";